import React from "react";

import { Button, Stack, styled, Typography } from "@mui/material";
import cx from "classnames";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

interface Props {
  value: string;
  secondary_pricing_title?: string;
  placedOnMarket: boolean | undefined;
  dealId?: number;
  aggregated?: boolean;
  indentation?: number;
  onPlaceOnMarket: (dealId: number) => void;
}

const StyledButton = styled(Button)({
  minWidth: 103,
  height: 24,
  whiteSpace: "nowrap"
});

export const PricingCell: React.FC<Props> = ({
  value,
  dealId,
  aggregated,
  secondary_pricing_title,
  placedOnMarket,
  onPlaceOnMarket
}) => {
  const isValueEmpty = value === "-" || !value;
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ whiteSpace: "nowrap", width: "100%" }}
    >
      <Stack>
        <Typography
          className={cx("measures-table__cell", { aggregated, is_deal: false })}
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: 400
          }}
        >
          <MaterialTooltip title={value} isShow>
            <Typography sx={{ width: "100px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {value || "-"}
            </Typography>
          </MaterialTooltip>
        </Typography>
        {secondary_pricing_title ? (
          <Typography
            sx={{
              fontSize: "12px",
              lineHeight: "16px",
              fontWeight: 400,
              color: "#FFFFFF",
              bgcolor: "#EBAF01",
              borderRadius: "20px",
              p: "4px"
            }}
          >
            {secondary_pricing_title}
          </Typography>
        ) : null}
      </Stack>
      {isValueEmpty ? null : (
        <>
          {placedOnMarket ? (
            <StyledButton size="sm" variant="contained">
              Placed
            </StyledButton>
          ) : (
            <StyledButton
              size="sm"
              variant="outlined"
              onClick={() => {
                if (!dealId) return;
                onPlaceOnMarket(dealId);
              }}
            >
              Place on market
            </StyledButton>
          )}
        </>
      )}
    </Stack>
  );
};
